import * as actionTypes from 'constants/ActionTypes';

export function getContracts() {
    return {
        type: actionTypes.GET_CONTRACTS.REQUEST,
    };
}

export function getTimeContracts() {
    return {
        type: actionTypes.GET_TIME_CONTRACTS.REQUEST,
    };
}



// WEBPACK FOOTER //
// ./app/actions/contracts.js